<template>
  <div
    id="banners"
    class="banners"
    v-bind:style="{backgroundImage:'url(' +'\''+ imageUrl +'\''+ ')', backgroundRepeat:'no-repeat'}"
    v-loading="loading"
  ></div>
</template>

<script>
export default {
  name: "banners",
  data() {
    return {
      imageUrl: "",
      loading: false
    };
  },
  props: ["pic"],
  methods: {
    handleCommand(command) {
      // console.log("click on item " + command);
    }
  },
  computed: {
    webInfo() {
      return this.$store.state.webInfo.configImgs;
    }
  },
  mounted() {
    this.loading = true;

    switch (this.pic) {
      case "pic1":
        this.imageUrl = this.webInfo.pic1;
        break;
      case "pic2":
        this.imageUrl = this.webInfo.pic2;
        break;
      case ' pic3':
        this.imageUrl = this.webInfo. pic3
        break;
      case 'downloadCentreChart':
        this.imageUrl = this.webInfo.downloadCentreChart
        break;
      default:
        break;
    }

    this.loading = false;
  }
};
</script>

<style scoped>
.banners {
  width: 100%;
  height: 300px;
  /* background: url("../../../static/images/banner02.jpg") no-repeat; */
  background-position: center;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/banners.vue